module.exports = __webpack_public_path__ + "static/media/artinii_logo_white.06276397.svg";